export enum BlockStateMode {
  BLOCK_LISTED = 'BLOCK_LISTED',
  ALLOW_LISTED = 'ALLOW_LISTED',
}

export interface IBlockedStatesConfig {
  blockStateMode: BlockStateMode;
  blockedStates: string[];
}
